import colors from '../../api/colors'

export default {
    namespaced: true,
    state: () => ({
        loading: false,
        items: []
    }),
    getters: {},
    actions: {
        getColors ({ commit }) {
            commit('setLoading', true)
            return colors.getColors().then((response) => {
                commit('setItems', response.data.colors)
                commit('setLoading', false)
            })
        }
    },
    mutations: {
        setLoading (state, bool) {
            state.loading = bool
        },
        setItems (state, colors) {
            state.items = colors
        }
    }
}
